export default "__VITE_ASSET__Dc5Ufc68__"